import React from "react";
import { useHistory } from "react-router-dom";
import { SmartIdWizardBooleanQuestionPage } from "../Shared/SmartIdWizardBooleanQuestionPage";

export function SmartIdRemoveBooleanQuestionStep({ onYesClicked }) {
  const history = useHistory();

  const onNoClicked = () => {
    history.push("/profileInformation");
  };

  return (
    <SmartIdWizardBooleanQuestionPage 
      onYesClicked={onYesClicked}
      onNoClicked={onNoClicked}
    />
  );
} 